const initialState = {
    isSheetSearchOpen: false,
};
const headerMobile = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_HEADER_MOBILE':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default headerMobile;
